import { Component, EventEmitter, forwardRef, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { Constants } from '../../../model/common.model';
import { PanelModule } from '../../../modules/panel.module';
import { MenuItemOptionChoiceComponent } from '../menu-item-option-choice/menu-item-option-choice.component';

@Component({
  selector: 'brt-menu-item-option',
  templateUrl: './menu-item-option.component.html',
  standalone: true,
  imports: [PanelModule, MenuItemOptionChoiceComponent],
  styleUrl: './menu-item-option.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MenuItemOptionComponent),
      multi: true
    }
  ]
})
export class MenuItemOptionComponent {
  types = Constants.MenuItemOptionTypes;
  value: any[];
  @Output() save = new EventEmitter<any>();

  choiceDialog: boolean;
  selected: any;

  addItem() {
    this.value.push({});
    this.onChange(this.value);
  }
  removeItem(index: number) {
    this.value.splice(index, 1);
    this.onChange(this.value);
  }

  writeValue(value: any[]) { this.value = value || []; }
  registerOnChange(fn: any) { this.onChange = fn; }
  registerOnTouched(fn: any) { this.onTouched = fn; }
  onChange = (_: any[]) => { };
  onTouched = () => { };
}
